import React, {useState} from 'react';
import { styled } from '@mui/material/styles';
import {Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography, Grid} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InputBox from './InputBox';
import { H3SubHeader, H4FormLabel } from '../../theme/Theme';
import ThemeColor from '../../theme/ThemeColor';
import { updateOfficeDetails } from '../../redux/Thunk/officeThunk';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function ProfileModel ({setOpenProfile, openProfile}) {
  const dispatch = useDispatch()
  const userDetails = JSON.parse(localStorage.getItem("userdetails"));

  const [profileDetails, setProfileDetails] = useState({
    // AdminId: userDetails?.AdminId ||'',
    OfficeName:userDetails?.OfficeName ||'',
    AdminName: userDetails?.AdminName ||'',
    Email: userDetails?.Email ||'',
    Mobile: userDetails?.Mobile ||'',
    Address: userDetails?.Address ||'',
    Role: userDetails?.Role ||'',
  })

  const handleChangeProfile =(e) =>{
    setProfileDetails({...profileDetails, [e.target.name]:e.target.value})
  }

  // Update Profile Details
  const handleSubmitProfile = () =>{
    profileDetails.AdminId = userDetails?.Role === 'Admin' ? userDetails?.AdminId :''
    profileDetails.OfficeId = userDetails?.Role != 'Admin' ? userDetails?.OfficeId :''
    dispatch(updateOfficeDetails(profileDetails)).then((res)=>{
      if(res.payload.success === false){
        sweetalert('error', res?.payload?.message)
        setOpenProfile(false);
      }else{
        sweetalert('success', res?.payload?.message)
        setProfileDetails({
          OfficeName:'',
          AdminName:'',
          Email:'',
          Mobile:'',
          Address:'',
          Role:'',
          // AdminId:''
        })
        setOpenProfile(false)
      }    
    }) 
  }

  const handleClose = () => {
    setOpenProfile(false);
  };

  const sweetalert = (variant, text) => {
    Swal.fire({
      icon: variant==='error' ? 'error' :'success',
      title: text , 
      button: "Ok!",
    }); 
  }

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openProfile}
        fullWidth
        maxWidth="md" 
      >
        <DialogTitle sx={{ m: 1, p: 1, color:'#004977', fontWeight:'bold'}} id="customized-dialog-title">
          User Profile
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
            <Grid container spacing={2} style={{ display: 'flex', padding:'0px 20px 20px 20px', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}> 
              {userDetails?.Role === 'Admin' ? <></> :<Grid size={{ xs: 12, sm: 12, md: 12, lg:12 }}>
                <H3SubHeader sx={{ color: '#004977' }}>{userDetails?.OfficeName} Office</H3SubHeader>
              </Grid> }
              <Grid size={{ xs: 12, sm: 6, md: 6, lg:6 }}>
                  <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Name</H4FormLabel>
                  <InputBox sx={{ borderRadius: '10px', backgroundColor: '#FFFFFF', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                    placeholder='Enter Name'
                    name='AdminName'
                    value={profileDetails?.AdminName}
                    onChange={handleChangeProfile}
                  />
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6, lg:6 }}>
                  <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Email</H4FormLabel>
                  <InputBox sx={{ borderRadius: '10px', backgroundColor: '#E9E9FF', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                    placeholder='Enter Email'
                    name='Email'
                    value={profileDetails?.Email}
                    onChange={handleChangeProfile}
                  />
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6, lg:6 }}>
                  <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Role</H4FormLabel>
                  <InputBox sx={{ borderRadius: '10px', backgroundColor: '#E9E9FF', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                    placeholder='Enter Role'
                    name='Role'
                    value={profileDetails?.Role}
                    onChange={handleChangeProfile}
                  />
              </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            id="save"
            variant="contained"
            onClick={handleSubmitProfile}
            sx={{color: '#FFFFFF', backgroundColor: '#04AB44',
              '&:hover': { backgroundColor: '#04AB44', color: '#FFFFFF' },
              fontSize: '16px', fontWeight: '500', borderRadius:"10px", pl:4, pr:4, textTransform: 'none', boxShadow:'0px 4px 6px #e1e1e1', mb:1, letterSpacing:'1px'
            }}>
            Save
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
